<div class="or-h-100dvh or-d-flex or-flex-col">
  <lib-auth-header text="Zaloguj się by korzystać z aplikacji"></lib-auth-header>

  <div class="or-flex-1 or-d-flex or-flex-col or-align-items-center or-justify-content-between">
    <div class="or-d-flex or-flex-col or-mx-16-px or-align-self-stretch margin-top--20-px">
      <button (click)="googleAuth()" class="or-bg-white border-radius-4 border-shade or-h-48-px or-head-xs or-w-100-pc">
        <div class="or-d-flex or-justify-content-center or-align-items-center">
          <img src="assets/icons/google-icon.svg" class="or-mr-8-px" /> Zaloguj się przez Google
        </div>
      </button>

      <button
        (click)="facebookAuth()"
        class="or-bg-white border-radius-4 border-shade or-h-48-px or-head-xs or-w-100-pc or-mt-12-px">
        <div class="or-d-flex or-justify-content-center or-align-items-center">
          <img src="assets/icons/facebook-icon.svg" class="or-mr-8-px" /> Zaloguj się przez Facebook
        </div>
      </button>

      @if (!isAndroid) {
        <button
          (click)="appleAuth()"
          class="or-bg-white border-radius-4 border-shade or-h-48-px or-head-xs or-w-100-pc or-mt-12-px">
          <div class="or-d-flex or-justify-content-center or-align-items-center">
            <img src="assets/icons/apple-icon.svg" class="or-mr-8-px" />
            Kontynuuj z Apple
          </div>
        </button>
      }

      <div class="or-my-20-px or-text-align-center or-text-sm or-color-secondary-2">lub</div>
      <button class="or-bg-white border-radius-4 border-shade or-h-48-px or-head-xs or-w-100-pc" (click)="goToLogin()">
        Zaloguj się e-mailem
      </button>

      <div class="or-head-xs or-my-24-px or-text-align-center">Nie masz konta?</div>

      <button
        class="or-color-white border-radius-4 or-h-48-px or-head-xs or-w-100-pc button-primary-style"
        (click)="goToRegister()">
        Zarejestruj się
      </button>
    </div>

    <div class="or-mt-16-px or-mb-24-px or-mx-16-px or-align-self-stretch">
      <button class="border-radius-4 border-shade or-bg-white or-h-48-px or-head-xs or-w-100-pc" (click)="goToMap()">
        Przejdź do mapy
      </button>

      <div class="or-text-sm or-text-align-center or-mt-16-px">
        Logując sie akceptujesz
        <span (click)="getTermsOfService()" class="or-text-decoration-underline or-color-primary or-cursor-pointer"
          >Regulamin</span
        >
        i
        <span (click)="getPolicyPrivacy()" class="or-text-decoration-underline or-color-primary or-cursor-pointer"
          >Politykę prywatności</span
        >
      </div>
    </div>
  </div>

  <div class="or-text-sm or-text-align-end or-mx-8-px or-mb-8-px">{{ appVersion }} ({{ buildVersion }})</div>
</div>
